import React from 'react'

const ICPUSD = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='32' height='17' viewBox='0 0 32 17' fill='none'>
      <g clipPath='url(#clip0_639_29334)'>
        <path
          d='M24.2184 0C22.4357 0 20.4836 0.971589 18.4245 2.88803C17.4529 3.78831 16.5972 4.76881 15.9733 5.5443C15.9733 5.5443 16.9716 6.69416 18.068 7.93316C18.6652 7.18441 19.512 6.16825 20.5014 5.25015C22.3287 3.53872 23.5231 3.19109 24.2095 3.19109C26.7766 3.19109 28.8624 5.3482 28.8624 8.01338C28.8624 10.6518 26.7766 12.8089 24.2095 12.8357C24.0847 12.8357 23.9421 12.8178 23.7638 12.7822C24.5125 13.1298 25.3237 13.3794 26.0814 13.3794C30.7878 13.3794 31.7148 10.1259 31.7683 9.89416C31.902 9.29695 31.9822 8.67299 31.9822 8.03121C31.9733 3.60112 28.497 0 24.2184 0Z'
          fill='url(#paint0_linear_639_29334)'
        />
        <path
          d='M7.77269 16.0266C9.55542 16.0266 11.5075 15.055 13.5666 13.1386C14.5382 12.2383 15.3939 11.2578 16.0178 10.4823C16.0178 10.4823 15.0195 9.33248 13.9231 8.09348C13.3259 8.84223 12.4791 9.85839 11.4897 10.7765C9.66239 12.4701 8.45904 12.8355 7.7816 12.8355C5.21447 12.8355 3.12868 10.6784 3.12868 8.01326C3.12868 5.37481 5.21447 3.21771 7.7816 3.19097C7.9064 3.19097 8.04901 3.2088 8.22729 3.24445C7.47854 2.89682 6.6674 2.64724 5.90974 2.64724C1.20333 2.63832 0.276306 5.89181 0.222824 6.13248C0.0891188 6.72969 0.00889587 7.35365 0.00889587 7.99543C0.00889587 12.4255 3.48522 16.0266 7.77269 16.0266Z'
          fill='url(#paint1_linear_639_29334)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.356 5.32145C10.839 4.82229 8.32535 2.78106 5.91866 2.70975C1.62228 2.60279 0.36545 5.72257 0.249573 6.12368C1.07854 2.62953 4.14484 0.0178273 7.78161 0C10.7499 0 13.7538 2.91477 15.9733 5.5443L15.9822 5.53538C15.9822 5.53538 16.9805 6.68524 18.0769 7.92424C18.0769 7.92424 19.3248 9.395 20.644 10.6875C21.161 11.1866 23.6657 13.2011 26.0724 13.2724C30.4847 13.3972 31.7059 10.0992 31.7683 9.84959C30.9571 13.3705 27.8819 15.9911 24.2273 16.0089C21.2591 16.0089 18.2552 13.0942 16.0267 10.4646C16.0267 10.4735 16.0178 10.4735 16.0178 10.4825C16.0178 10.4825 15.0195 9.3326 13.9231 8.0936C13.932 8.0936 12.6841 6.61394 11.356 5.32145Z'
          fill='#29ABE2'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_639_29334'
          x1='20.0455'
          y1='1.26988'
          x2='31.0343'
          y2='12.3492'
          gradientUnits='userSpaceOnUse'>
          <stop offset='0.21' stopColor='#F15A24' />
          <stop offset='0.6841' stopColor='#FBB03B' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_639_29334'
          x1='11.9484'
          y1='14.7586'
          x2='0.959562'
          y2='3.67931'
          gradientUnits='userSpaceOnUse'>
          <stop offset='0.21' stopColor='#ED1E79' />
          <stop offset='0.8929' stopColor='#522785' />
        </linearGradient>
        <clipPath id='clip0_639_29334'>
          <rect width='31.9822' height='16.0268' fill='white' transform='translate(0.00889587)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ICPUSD
